export default __webpack_public_path__ + "static/media/A Father's Devotion.af08747d.jpg";